import { type GlobalConfig } from "./global-config.type";

export const GLOBAL_CONFIG_DEFAULTS: GlobalConfig = {};
